module.exports = __webpack_public_path__ + "be8a7f04b169d135cf97370c4a14debb.png";